import { useLayoutEffect } from 'react'
import { Link } from 'react-router-dom'
import { useAbp } from '../platform/abp/react'
import { dismissHtmlBootSplash } from '../platform/ui/bootSplash'
import { HOME_PATH, LOGIN_PATH } from './pathPolicy'
import './NotFoundPage.css'

export function NotFoundPage() {
  // Local token seed is enough for CTA; no need to wait on probeSession.
  const { isAuthenticated } = useAbp()

  useLayoutEffect(() => {
    dismissHtmlBootSplash()
  }, [])

  return (
    <div className="app-not-found">
      <div className="app-not-found-card">
        <h1 className="app-not-found-title">Page not found</h1>
        <p className="app-not-found-lead">
          {isAuthenticated
            ? 'This address is not valid. Check the link or return home.'
            : 'This address is not valid. Check the link or return to login.'}
        </p>
        {isAuthenticated ? (
          <Link to={HOME_PATH} className="app-not-found-link">
            Go home
          </Link>
        ) : (
          <Link to={LOGIN_PATH} className="app-not-found-link">
            Go to login
          </Link>
        )}
      </div>
    </div>
  )
}
